import React from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { Navbar } from './components/Navbar';
import { HeroSection } from './components/HeroSection';
import { HowItWorks } from './components/HowItWorks';
import { CTASection } from './components/CTASection';
import { Footer } from './components/Footer';
import { CookieBanner } from './components/CookieBanner';
import { NosotrosPage } from './pages/NosotrosPage';
import { ParticipantesPage } from './pages/ParticipantesPage';
import { PrivacidadPage } from './pages/PrivacidadPage';
import { TerminosPage } from './pages/TerminosPage';
import { CookiesPage } from './pages/CookiesPage';
import { ByeByeAdminPage } from './pages/ByeByeAdminPage';
function HomePage() {
  return <>
      <HeroSection data-id="element-0" />
      <HowItWorks data-id="element-1" />
      <CTASection data-id="element-2" />
    </>;
}
function AppLayout() {
  const location = useLocation();
  const isBarePage = location.pathname === '/byebyeadmin';
  return <div className="min-h-screen bg-white font-sans text-gray-900 selection:bg-brand-gold selection:text-brand-navy" data-id="element-3">
      {!isBarePage && <Navbar data-id="element-4" />}
      <main data-id="element-5">
        <Routes data-id="element-6">
          <Route path="/" element={<HomePage data-id="element-8" />} data-id="element-7" />
          <Route path="/nosotros" element={<NosotrosPage data-id="element-10" />} data-id="element-9" />
          <Route path="/participantes" element={<ParticipantesPage data-id="element-12" />} data-id="element-11" />
          <Route path="/politica-de-privacidad" element={<PrivacidadPage data-id="element-14" />} data-id="element-13" />
          <Route path="/terminos-de-uso" element={<TerminosPage data-id="element-16" />} data-id="element-15" />
          <Route path="/cookies" element={<CookiesPage data-id="element-18" />} data-id="element-17" />
          <Route path="/byebyeadmin" element={<ByeByeAdminPage data-id="element-20" />} data-id="element-19" />
        </Routes>
      </main>
      {!isBarePage && <Footer data-id="element-21" />}
      {!isBarePage && <CookieBanner data-id="element-22" />}
    </div>;
}
export function App() {
  return <BrowserRouter data-id="element-23">
      <AppLayout data-id="element-24" />
    </BrowserRouter>;
}